import { WhiteLabelStyles } from 'signer-app/white-labeling/types';

export const defaultWhiteLabelStyles = {
  pageBackgroundColor: '#f7f8f9',
  headerBackgroundColor: '#1a1a1a',
  legalVersion: 'terms1',
  linkColor: '#0061FE',
  primaryButtonColor: '#0061FE',
  primaryButtonColorHover: '#0061FE',
  primaryButtonTextColor: '#ffffff',
  primaryButtonTextColorHover: '#ffffff',
  secondaryButtonColor: '#ffffff',
  secondaryButtonColorHover: '#ffffff',
  secondaryButtonTextColor: '#0061FE',
  secondaryButtonTextColorHover: '#0061FE',
  textColor1: '#808080',
  textColor2: '#ffffff',
} satisfies WhiteLabelStyles;

/**
 * A set of themes that we can use for testing.
 */
export const themes = {
  sign: defaultWhiteLabelStyles,

  dark: {
    pageBackgroundColor: '#cfeae7',
    headerBackgroundColor: '#19312e',
    legalVersion: 'terms1',
    linkColor: '#19312e',
    primaryButtonColor: '#965d51',
    primaryButtonColorHover: '#774a40',
    primaryButtonTextColor: '#f0e1df',
    primaryButtonTextColorHover: '#ff0000',
    secondaryButtonColor: '#19312e',
    secondaryButtonColorHover: '#254643',
    secondaryButtonTextColor: '#cfeae7',
    secondaryButtonTextColorHover: '#99d7cf',
    textColor1: '#19312e',
    textColor2: '#cfeae7',
  },

  light: {
    pageBackgroundColor: '#ff0000',
    headerBackgroundColor: '#dfcacd',
    legalVersion: 'terms2',
    linkColor: '#ff0000',
    primaryButtonColor: '#FF5c00',
    primaryButtonColorHover: '#FF5c00',
    primaryButtonTextColor: '#ede2e3',
    primaryButtonTextColorHover: '#c4969c',
    secondaryButtonColor: '#FFCD9B',
    secondaryButtonColorHover: '#FFCD9B',
    secondaryButtonTextColor: '#3a272a',
    secondaryButtonTextColorHover: '#55393d',
    textColor1: '#000000',
    textColor2: '#0f0f0f',
  },

  vis2023: {
    pageBackgroundColor: '#ffffff',
    headerBackgroundColor: '#f7f5f2',
    legalVersion: 'terms1',
    linkColor: '#0061fe',
    primaryButtonColor: '#0061fe',
    primaryButtonColorHover: '#004dc7',
    primaryButtonTextColor: '#f2f7ff',
    primaryButtonTextColorHover: '#f2f7ff',
    secondaryButtonColor: '#ffffff',
    secondaryButtonColorHover: '#ebe9e6',
    secondaryButtonTextColor: '#1a1918',
    secondaryButtonTextColorHover: '#1a1918',
    textColor1: '#1a1918',
    textColor2: '#736c64',
  },
} satisfies Record<string, WhiteLabelStyles>;

export type ThemeName = keyof typeof themes;
